import { render } from "./AtlasSignature.vue?vue&type=template&id=42681278&scoped=true"
import script from "./AtlasSignature.vue?vue&type=script&lang=js"
export * from "./AtlasSignature.vue?vue&type=script&lang=js"

import "./AtlasSignature.vue?vue&type=style&index=0&id=42681278&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42681278"]])

export default __exports__